package com.mps.asc_app.data.user

enum class UserStatus {
    EMAIL_NOT_VERIFIED,
    PENDING,
    APPROVED
}